import React from 'react';
import classNames from 'classnames';

import CircularProgress from 'components/Base/CircularProgress';

import styles from './Loader.module.scss';

interface LoaderProps {
  fullScreen?: boolean;
}

const Loader = ({ fullScreen }: LoaderProps) => {
  return (
    <div className={classNames(styles.loader_container, { [styles.full_screen]: fullScreen })}>
      <div className={styles.loaderWrapper}>
        <CircularProgress />
      </div>
    </div>
  );
};

export default Loader;
